<template>
  <div>
    <el-form :model="formData" size="small" label-width="80px">
      <el-form-item label="用户" v-if="JSON.stringify(data) === '{}'">
        <el-select
          v-model="userId"
          filterable
          remote
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          :loading="loading"
          style="width: 220px;"
          @change="handleUserInfoChange">
          <el-option
            v-for="item in userList"
            :key="item.userId"
            :label="`${item.employeeName}-${item.employeeCode}`"
            :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户" v-else>
        {{formData.employeeName + '-' + formData.employeeCode}}
      </el-form-item>
      <el-form-item label="店铺">
        <el-select v-model="formData.storeId" multiple collapse-tags placeholder="请选择" style="width: 220px;">
          <el-option
            v-for="item in authOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import mixin from '@/views/preSalePlan/utils/mixin.js'
export default {
  mixins: [mixin],
  props: ['data'],
  data() {
    return {
      formData: {},
      userId: '',
      userList: [],
      loading: false
    }
  },
  mounted() {
    let formData = JSON.parse(JSON.stringify(this.data));
    formData['storeId'] = formData['storeId'] && formData['storeId'].split(',');
    this.formData = formData;
  },
  methods: {
    remoteMethod(query) {
      this.loading = true;
      this.$q.preSalePlan.planUsers({params: { userName: query }})
      .then(res=>{
        this.userList = res.data;
        this.loading = false;
      })
    },
    handleUserInfoChange(data) {
      const activeObj = this.userList.find(v=>v.userId === this.userId);
      this.formData['userId'] = activeObj.userId;
      this.formData['employeeCode'] = activeObj.employeeCode;
      this.formData['employeeName'] = activeObj.employeeName;
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
    width 100% !important
  >>> .el-input
    width 100% !important
</style>